
(function () {
    'use strict';

    angular
        .module('rms.common')
        .directive('rmsFieldSectionCounter', rmsFieldSectionCounter);

    function rmsFieldSectionCounter() {
        return {
            restrict: 'E',
            require: 'ngModel',
            scope: {
                max: '=?',
            },
            templateUrl: 'common/app/components/manage-form/section-counter',
            link: function(scope, elem, attr, ctrl) {
                var _ctrl = scope.ctrl;
                _ctrl.increment = increment;
                _ctrl.decrement = decrement;

                if (!scope.max) {
                    scope.max = 20;
                }

                _ctrl.value = 0;

                ctrl.$render = function () {
                    _ctrl.value = ctrl.$viewValue || 0;
                }

                function increment() {
                    if (_ctrl.value >= scope.max) {
                        return;
                    }
                    _ctrl.value += 1;
                    ctrl.$setViewValue(_ctrl.value);
                }

                function decrement() {
                    if (_ctrl.value > 0) {
                        _ctrl.value -= 1;
                        ctrl.$setViewValue(_ctrl.value);
                    }
                }
            },
            controller: rmsFieldSectionCounterCtrl,
            controllerAs: 'ctrl',
            bindToController: true,
        };
    }

    function rmsFieldSectionCounterCtrl($scope) {

    }
})();